<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="d-md-flex align-items-center col-sm-6">
                    <div>
                      <h4 class="card-title">
                        {{ title }}
                      </h4>
                      <h5 class="card-subtitle">
                        {{ subtitle }}&nbsp;
                      </h5>
                    </div>
                  </div>
                  <div class="col-sm-6 text-right">
                    <slot name="button" />
                  </div>
                </div>
                <slot name="filter" />
                <slot name="table" />
              </div>
              <!-- <slot name="pagenator" /> -->
              <div v-if="totalRows>5" class="card-footer">
                <div class="row">
                  <div class="col">
                    <per-page v-model="internalPerPage" />
                  </div>
                  <div v-if="totalRows>internalPerPage" class="col-auto">
                    <b-pagination v-model="internalCurrentPage" :total-rows="totalRows" :per-page="internalPerPage" />
                  </div>
                </div>
              </div>
              <slot name="modals" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PerPage from '@/components/protected/common/PerPage.vue'
import { generatePropSyncMixin } from '@/utils/sync-prop'

export default {
  name: 'PageTable',
  components: { PerPage },
  mixins: [
    generatePropSyncMixin('internalPerPage', 'perPage'),
    generatePropSyncMixin('internalCurrentPage', 'currentPage')
  ],
  props: ['title', 'subtitle', 'totalRows', 'currentPage', 'perPage']
}
</script>
